import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useContext, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { collection, addDoc } from 'firebase/firestore';
import Swal from 'sweetalert2';
import { AppContext } from '../../../../Context';
import { db } from '../../../../firebase/firebase';

const gruposDeRaices = [
  {
    raiz: 'Raíz: sumptum, sumpsi = consumir',
    campos: [{ id: 'consumo', etiqueta: 'Consumo' }],
  },
  {
    raiz: 'Raíz: lumien = luz, lumbre',
    campos: [
      { id: 'luminaria', etiqueta: 'Luminaria' },
      { id: 'luminoso', etiqueta: 'Luminoso' },
    ],
  },
  {
    raiz: 'Raíz: multus = muchos',
    campos: [
      { id: 'multiplicar', etiqueta: 'Multiplicar' },
      { id: 'multiforme', etiqueta: 'Multiforme' },
      { id: 'multigenero', etiqueta: 'Multigénero' },
    ],
  },
  {
    raiz: 'Raíz: ulter, ultra = más allá, posterior, espacios',
    referencia: 'Ultravirus: virus exageradamente pequeño',
    campos: [
      { id: 'ultratumba', etiqueta: 'Ultratumba' },
      { id: 'ulterior', etiqueta: 'Ulterior' },
      { id: 'ultimo', etiqueta: 'Último' },
      { id: 'ultramar', etiqueta: 'Ultramar' },
      { id: 'ultimar', etiqueta: 'Ultimar' },
      { id: 'ultrarrapido', etiqueta: 'Ultrarrápido' },
    ],
  },
];

const campos = gruposDeRaices.flatMap(({ campos: camposDelGrupo }) => camposDelGrupo);
const respuestasIniciales = Object.fromEntries(campos.map(({ id }) => [id, '']));

const M10_Ejercicio7 = ({ cerrarModal }) => {
  const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
  const [respuestas, setRespuestas] = useState(respuestasIniciales);

  const handleChange = ({ target: { name, value } }) => {
    setRespuestas((respuestasActuales) => ({
      ...respuestasActuales,
      [name]: value,
    }));
  };

  const enviarResultados = async (event) => {
    event.preventDefault();
        if (modoConsulta) { cerrarModal?.(); return; }


    if (!campos.every(({ id }) => respuestas[id].trim() !== '')) {
      await Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Completa todos los campos obligatorios antes de enviar la evaluación.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    try {
      await addDoc(collection(db, 'evaluaciones'), {
        userId: currentUser.uid,
        nombre: 'Ejercicio de Comprensión - Ejercicio 7: Raíces latinas',
        nivel: 'Intermedio',
        modulo: '10',
        createdAt: new Date(),
        tipo: 'Texto libre',
        respuestas,
      });

      const result = await Swal.fire({
        title: '¡Evaluación enviada!',
        text: 'Tus respuestas se guardaron correctamente.',
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Excelente',
      });

      if (result.isConfirmed) {
        cerrarModal();
      }
    } catch (error) {
      console.error('Error al enviar las respuestas:', error);
      Swal.fire({
        icon: 'error',
        title: 'No se pudo enviar la evaluación',
        text: 'Tus respuestas no se guardaron. Verifica tu conexión e inténtalo nuevamente.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
      });
    }
  };

  return (
    <div className="container mt-4">
      <h2>Ejercicio de Comprensión</h2>
      <p><strong>Ejercicio 7: Raíces latinas</strong></p>
      <p className="text-muted">Escribe el significado de cada palabra según la raíz latina indicada.</p>

      <Form onSubmit={enviarResultados}>
        <Row>
          {gruposDeRaices.map(({ raiz, referencia, campos: camposDelGrupo }) => (
            <Col md={6} key={raiz} className="mb-4">
              <Card className="h-100 border">
                <Card.Body>
                  <Card.Title as="h3" className="h5">{raiz}</Card.Title>
                  {referencia && <p className="text-muted">{referencia}</p>}

                  {camposDelGrupo.map(({ id, etiqueta }) => (
                    <Form.Group className="mb-3" controlId={id} key={id}>
                      <Form.Label>{etiqueta}</Form.Label>
                      <Form.Control
                        type="text"
                        name={id}
                        value={respuestas[id]}
                        onChange={handleChange}
                        aria-label={`Significado de ${etiqueta}`}
                      />
                    </Form.Group>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <Button type="submit" variant="primary">Enviar resultados</Button>
      </Form>
    </div>
  );
};

export default M10_Ejercicio7;
